import { v$,listen,compose,generateBooleanArr } from './helpers.js';


let reviewPopup = v$('#full_reviews')[0],
    closeBtn    = v$('.popup-close ',reviewPopup)[0];

const getContent = target => {
    return {
        fullContent: v$('.reviews-full_content',target)[0] ? v$('.reviews-full_content',target)[0].innerText : false,
        rate: generateBooleanArr(v$('.fa-star',target).length,5),
        personName: v$('.reviews-name',target)[0].innerText,
        title: v$('.reviews-impression',target)[0].innerText,
        date: v$('.date',target)[0].innerText,
        target:reviewPopup
    }
}
const pushDataToPopup = obj => {
    // here we push value to popup
    let contentBlock = v$('.reviews-item',obj.target)[0];
    const innerHtml = `
    <div class="reviews-item-content">
        <div>
            <span class="date">${obj.date}</span>
            <span class="reviews-mark starrr_small">
                <span class="fa ${obj.rate[0] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                <span class="fa ${obj.rate[1] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                <span class="fa ${obj.rate[2] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                <span class="fa ${obj.rate[3] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                <span class="fa ${obj.rate[4] ? 'fa-star' : 'fa-star-o'}" href=""></span>
            </span>
        </div>
        <span class="reviews-name">${obj.personName}</span>
        <span class="reviews-impression">${obj.title}</span>
        <p>${obj.fullContent ? obj.fullContent : 'Надо добавить блок полного котнента'}</p>
    </div>
    `;
    contentBlock.innerHTML = innerHtml;
    return obj.target;
}
const showPopup = (target) => {
    target.classList.add('active');
}

const showFullReview =  compose(
    showPopup,
    pushDataToPopup,
    getContent
);

document.body.addEventListener('click',e => {
    if(e.target.className === 'reviews-full'){
        showFullReview(e.target.parentNode);
    }
})
closeBtn.addEventListener('click', e => {
    reviewPopup.classList.remove('active');
})
